import Title from "@/components/Title/Title";
import { Wysiwyg } from "@/styles/typography";
import React from "react";
import S from "./Diagram.Styled";
import { Pie } from "react-chartjs-2";
import { Tooltip } from "chart.js";
import { Chart, ArcElement } from "chart.js";

Chart.register(ArcElement, Tooltip);

export interface Props {
  title: string;
  text: string;
  layout: string;
  diagramData: {
    label: string;
    value: number;
  }[];
}

const Diagram = ({ title, text, layout, diagramData }: Props) => {
  const chartData = {
    labels: diagramData.map(({ label }) => label),
    datasets: [
      {
        label: "",
        data: diagramData.map(({ value }) => value),
        backgroundColor: ["white"],
        borderColor: "black",
        borderWidth: 1,
      },
    ],
  };

  const renderDiagram = diagramData.map((item, index) => {
    if (layout === "standing_bar") {
      return (
        <S.StandingBar key={index} value={item.value}>
          <S.Value>{item.value}%</S.Value>
          <S.Label>{item.label}</S.Label>
        </S.StandingBar>
      );
    }
    return (
      <S.LyingBar key={index} value={item.value}>
        <S.Value>{item.value}%</S.Value>
        <S.LyingLabel>{item.label}</S.LyingLabel>
      </S.LyingBar>
    );
  });

  return (
    <div className="main-inner">
      <S.Container>
        <S.TextWrapper>
          <Title title={title} backgroundColor={"blue"} />
          <Wysiwyg color="white" dangerouslySetInnerHTML={{ __html: text }} />
        </S.TextWrapper>
        {layout === "standing_bar" && (
          <S.StandingDiagram>{renderDiagram}</S.StandingDiagram>
        )}
        {layout === "lying_bar" && (
          <S.LyingDiagram>{renderDiagram}</S.LyingDiagram>
        )}
        {layout === "pie" && (
          <S.Pie>
            <Pie
              data={chartData}
              options={{
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (item) => `${item.label}: ${item.formattedValue}%`,
                    },
                  },
                },
              }}
            />
          </S.Pie>
        )}
      </S.Container>
    </div>
  );
};

export default Diagram;
